import countiesServiceGen from "./generated/countiesServiceGen";

class countiesService extends countiesServiceGen {
}

export default countiesService;